<template>
	<div class="relative">
		<input
			:id="`passwordfield_${uid}`"
			type="password"
			:name="name"
			:value="modelValue"
			:disabled="disabled"
			placeholder=" "
			:autocomplete="autocomplete"
			:data-cy="name ? `input_${name}` : null"
			:class="{
        'block w-full py-2.5 px-0 text-sm  bg-transparent border-0 border-b-2 appearance-none focus:outline-hidden focus:ring-0 peer': true,
        'text-qwr-dark border-qwr-dark-200 focus:border-primary': !hasError,
        'text-red-600 border-red-600': hasError,
      }"
			@input="commitChanges"
		/>
		<label
			:for="`passwordfield_${uid}`"
			:class="{
      'absolute text-sm text-qwr-dark duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-0 peer-focus:text-primary peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6': true,
      'text-red-600': hasError,
    }"
		>
			<slot />
		</label>
		<ErrorBag :errors="errors" :is-notice="isChanged" />
	</div>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance, ref, watch } from 'vue';
import ErrorBag from '@/components/ErrorBag.vue';

export interface Props {
  name?: string
  autocomplete?: string
  placeholder?: string
  modelValue?: string | null
  disabled?: boolean
  errors?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  name: undefined,
  autocomplete: undefined,
  placeholder: undefined,
  modelValue: undefined,
  disabled: false,
  errors: undefined,
});

const uid = getCurrentInstance()?.uid

const isChanged = ref(false);

const hasError = computed(() => props.errors && props.errors.length > 0 && !isChanged.value);

watch(() => props.errors, () => {
  isChanged.value = false;
});

const emit = defineEmits([
  'update:modelValue',
]);

const commitChanges = (event: Event) => {
  isChanged.value = true;
  emit('update:modelValue', (event.target as HTMLInputElement).value);
};
</script>
